<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script type="text/ecmascript-6">
import store from './vuex/store.js'
export default {
  name: 'App',
  data(){
    return{
      currentTheme :"lightBlue"
    }
  },
  computed: {
    skin () {
      return store.getters.getSkin
    }
  },
  mounted () {
    let vm = this
    vm.$nextTick(() => {
      // 目前内页固定使用浅色
      vm.currentTheme = "lightBlue"

      let currentTheme = localStorage.getItem('themePage')||"midNightBlue"
      let className = document.body.className ? document.body.className.split(' ') : []
      className.push(`${vm.currentTheme} ${currentTheme}Theme`)
      document.body.className = className.join(' ')
    })
  }
}
</script>

<style lang="scss">
@import './style/common.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue